export * from '@fhs/routing/src/routes/rewards/offers/[incentiveId]';
export { default } from '@fhs/routing/src/routes/rewards/offers/[incentiveId]';
